import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { useValue } from 'components/form/hook/useValue';
import { SegmentedControl } from 'components/SegmentedControl';
import { React } from 'libs/react';
import './SaleItemConfigurationField.scss';
/**
 * Choix compact du type de produit (champ « configuration ») : contrôle
 * segmenté, description du type choisi et avis éventuel.
 * @component SaleItemConfigurationField
 * @since 1.0.0
 */
export function SaleItemConfigurationField(props) {
    const { options, value, notice } = props;
    useValue('configuration', value, 'SIMPLE');
    const selected = options.find((option) => option.value === value);
    return (React.createElement("div", { className: "sale-item-configuration-field" },
        React.createElement("div", { className: "sale-item-configuration-field-head" },
            React.createElement(FormFieldLabel, { label: t('Product type'), required: true }),
            options.length > 1 ? (React.createElement(SegmentedControl, { label: t('Product type'), options: options, value: value, onChange: props.onChange })) : (React.createElement("span", { className: "sale-item-configuration-field-value" }, selected === null || selected === void 0 ? void 0 : selected.label))),
        (selected === null || selected === void 0 ? void 0 : selected.infos) && (React.createElement("div", { className: "sale-item-configuration-field-infos" }, selected.infos)),
        notice && (React.createElement("div", { className: "sale-item-configuration-field-notice" }, notice))));
}
